module.exports = __webpack_public_path__ + "static/media/line-chart.e47e36a1.png";